import React, { useMemo, useState } from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import copy from 'copy-to-clipboard';
import { Icon, Tooltip } from 'antd';
import { withRouter } from 'react-router-dom';

import ZoomableImageView from './ZoomableImageView';
import { FILE_URLS } from '../../constants/Common';
import { LOCAL_STORAGE_VAR } from '../../constants/Common';
import IntlMessages from '../../util/IntlMessages';
import { isMobile } from '../../components/DiamondList/DiamondListFunctions';
import img from './../../assets/img/no_img.jpeg';
import { ImageWithView } from './ImageWithView';

const DiamondDetailLeft = (props) => {
  const [copyText, setCopyText] = useState('Copy URL');
  const [loadError, setLoadError] = useState({
    image: false,
    video: false,
    hAFile: false,
    arrowFile: false,
    assetFile: false,
    fluorescenceFile: false,
    blackBackgroundFile: false,
    certImg: false,
    plotImg: false,
  });

  const hasToken = !!localStorage.getItem(`${LOCAL_STORAGE_VAR}-token`);
  const hasSharedFlag = (flag) => props.shared.some((item) => item === flag);

  const initialTab = useMemo(() => {
    if (hasSharedFlag('isImg=true')) return '1';
    if (hasSharedFlag('isVideo=true')) return '2';
    if (hasSharedFlag('isHa=true')) return '3';
    if (hasSharedFlag('isCert=true')) return '4';
    if (hasSharedFlag('isProportion=true')) return '5';
    if (hasSharedFlag('isArrow=true')) return '7';
    if (hasSharedFlag('isAsset=true')) return '8';
    if (hasSharedFlag('flsImage=true')) return '9';
    // if (hasSharedFlag('isBlackBackground=true')) return '10';
    if (props.item.img) return '1';
    if (props.item.videoFile) return '2';
    if (props.item.hAFile) return '3';
    if (props.item.certFile) return '4';
    if (props.item.arrowFile) return '7';
    if (props.item.assetFile) return '8';
    if (props.item.fluorescenceFile) return '9';
    // if (props.item.blackBackgroundFile) return '10';
    return '';
  }, [props.item, props.shared]);

  const [activeTab, setActiveTab] = useState(initialTab);

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };
  const setError = (key) => setLoadError((prev) => ({ ...prev, [key]: true }));
  if (!activeTab) return <></>;

  const copyURL = (url) => {
    setCopyText('Copied!!');
    copy(url);
  };

  const renderImageContent = (src, options = {}) =>
    isMobile() ? (
      <ImageWithView src={src} />
    ) : (
      <ZoomableImageView src={src} initialZoom={options.zoom} />
    );

  const tabConfig = [
    {
      id: '1',
      label: <IntlMessages id="app.Image" />,
      paneClassName: 'hv-600',
      showContent: props.item.img && (hasToken || hasSharedFlag('isImg=true')),
      showNav: props.item.img && (hasToken || hasSharedFlag('isImg=true')),
      thumbSrc: loadError.image ? img : FILE_URLS.img.replace('***', props.item.vStnId),
      onThumbError: () => setError('image'),
      content: renderImageContent(FILE_URLS.img.replace('***', props.item.vStnId)),
    },
    {
      id: '2',
      label: <IntlMessages id="app.Video" />,
      paneClassName: 'mb-17',
      showContent: props.item.videoFile && (hasToken || hasSharedFlag('isVideo=true')),
      showNav: props.item.videoFile && (hasToken || hasSharedFlag('isVideo=true')),
      thumbSrc: loadError.video || loadError.image ? img : FILE_URLS.img.replace('***', props.item.vStnId),
      onThumbError: () => setError('video'),
      content: (
        <div className="diamondDetailImageBox htmlViewImage dna-mobile">
          <iframe
            allowFullScreen
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            key={Math.random()}
            src={FILE_URLS.videoFile.replace('***', props.item.vStnId)}
            title="vFile"
            onError={() => setError('video')}
          />
        </div>
      ),
      copyable: true,
      wrapContent: false,
    },
    {
      id: '3',
      label: 'Heart',
      showContent: props.item.hAFile && props.item.shpNm === 'ROUND' && (hasToken || hasSharedFlag('isHa=true')),
      showNav: props.item.hAFile && props.item.shpNm === 'ROUND' && (hasToken || hasSharedFlag('isHa=true')),
      thumbSrc: loadError.hAFile ? img : FILE_URLS.hAFile.replace('***', props.item.vStnId),
      onThumbError: () => setError('hAFile'),
      content: renderImageContent(FILE_URLS.hAFile.replace('***', props.item.vStnId)),
    },
    {
      id: '4',
      label: <IntlMessages id="app.Certificate" />,
      showContent: props.item.certFile && (hasToken || hasSharedFlag('isCert=true')),
      showNav: props.item.certFile && (hasToken || hasSharedFlag('isCert=true')),
      thumbSrc: loadError.certImg ? img : FILE_URLS.certImg.replace('***', props.item.rptNo),
      onThumbError: () => setError('certImg'),
      content: renderImageContent(FILE_URLS.certImg.replace('***', props.item.rptNo), { zoom: 1.4 }),
    },
    {
      id: '5',
      label: <IntlMessages id="app.Proportions" />,
      paneClassName: 'hv-600',
      showContent: hasToken && props.item.crt >= 1,
      showNav: ((hasToken && props.item.rptNo) || hasSharedFlag('isProportion=true')) && props.item.crt >= 1,
      thumbSrc: require('./../../assets/img/DiamondDetail/proportion.png'),
      content: (
        <>
          <div
            className="diamondDetailImageBox proportions"
            style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
          >
            <div className="diamondDetailWrapper" style={{ padding: '0px' }}>
              <img src={require('./../../assets/img/DiamondDetail/proportion.png')} className="diamondImage" />
              <div className="top-labels-container">
                <div className=" label-left-length">L: {props.item.length}</div>
                <div className=" label-top-width">W: {props.item.width}</div>
                <div className="label label-right-height">H: {props.item.height}</div>
              </div>
              <div className="sec-part-container">{props.item.tblPer ? `${props.item.tblPer}%` : ''}</div>
              <div className="third-part-container-right">{props.item.depPer ? `${props.item.depPer}%` : ''}</div>
              <div className="label-left-cHgt">{props.item.cHgt ? `${props.item.cHgt}%` : ''}</div>
              <div className="label-left-pHgt">{props.item.pHgt ? `${props.item.pHgt}%` : ''}</div>
              <div className="label-left-grdlPer">{props.item.grdlPer ? `${props.item.grdlPer}%` : ''}</div>
              <div className="label-left-strLn">{props.item.strLn ? `${props.item.strLn}%` : ''}</div>
              <div className="label-left-lwrHal">{props.item.lwrHal ? `${props.item.lwrHal}%` : ''}</div>
              <div className="label-left-cAng">{props.item.cAng ? `${props.item.cAng}°` : ''}</div>
              <div className="label-left-pAng">{props.item.pAng ? `${props.item.pAng}°` : ''}</div>
            </div>

            {/* // Diamond Detail Text */}
            <div className="label-left-text">
              {props.item.isFcCol && props.item.ratio && (
                <div className="label-left-ratio">
                  <span>
                    <b>Ratio :</b> {props.item.ratio}
                  </span>
                </div>
              )}
              {props.item.grdlDesc ? (
                <div className="label-left-grdlDesc">
                  <span>
                    <b>Girdle (Desc.) :</b> {props.item.grdlDesc}
                  </span>
                </div>
              ) : null}
              {props.item.kToSStr ? (
                <div className="label-left-kToSStr">
                  <span>
                    <b>Key To Symbol :</b> {props.item.kToSStr}
                  </span>
                </div>
              ) : null}
              {props.item.cmt ? (
                <div className="label-left-cmt">
                  <span>
                    <b>Comments :</b> {props.item.cmt}
                  </span>
                </div>
              ) : null}
            </div>

            {props.item.rptNo && props.item.lbNm === 'GIA' && !loadError.plotImg && (
              <img
                className="plot-img"
                src={FILE_URLS.plotImg.replace('***', props.item.rptNo)}
                onError={() => setError('plotImg')}
              />
            )}
          </div>
        </>
      ),
      wrapContent: false,
    },
    {
      id: '7',
      label: <IntlMessages id="app.Arrow" />,
      showContent: props.item.arrowFile && props.item.shpNm === 'ROUND' && hasToken,
      showNav: props.item.arrowFile && props.item.shpNm === 'ROUND' && (hasToken || hasSharedFlag('isArrow=true')),
      thumbSrc: loadError.arrowFile ? img : FILE_URLS.arrowFile.replace('***', props.item.vStnId),
      onThumbError: () => setError('arrowFile'),
      content: renderImageContent(FILE_URLS.arrowFile.replace('***', props.item.vStnId)),
    },
    {
      id: '8',
      label: <IntlMessages id="app.Asset" />,
      showContent: props.item.assetFile && hasToken,
      showNav: props.item.assetFile && (hasToken || hasSharedFlag('isAsset=true')),
      thumbSrc: loadError.assetFile ? img : FILE_URLS.assetFile.replace('***', props.item.vStnId),
      onThumbError: () => setError('assetFile'),
      content: renderImageContent(FILE_URLS.assetFile.replace('***', props.item.vStnId)),
    },
    {
      id: '9',
      label: <IntlMessages id="app.compare.flo" />,
      showContent: props.item.fluorescenceFile && hasToken,
      showNav: props.item.fluorescenceFile && (hasToken || hasSharedFlag('flsImage=true')),
      thumbSrc: loadError.fluorescenceFile ? img : FILE_URLS.fluorescenceFile.replace('***', props.item.vStnId),
      onThumbError: () => setError('fluorescenceFile'),
      content: renderImageContent(FILE_URLS.fluorescenceFile.replace('***', props.item.vStnId)),
    },
    // {
    //   id: '10',
    //   label: <IntlMessages id="app.blackBackground" />,
    //   showContent: props.item.blackBackgroundFile && hasToken,
    //   showNav: props.item.blackBackgroundFile && hasToken,
    //   thumbSrc: loadError.blackBackgroundFile ? img : FILE_URLS.blackBackgroundFile.replace('***', props.item.vStnId),
    //   onThumbError: () => setError('blackBackgroundFile'),
    //   content: renderImageContent(FILE_URLS.blackBackgroundFile.replace('***', props.item.vStnId)),
    // },
  ];

  const visibleContentTabs = tabConfig.filter((tab) => tab.showContent);
  const visibleNavTabs = tabConfig.filter((tab) => tab.showNav);

  return (
    <>
      <>
        {hasToken || props.shared.length > 1 ? (
          <TabContent activeTab={activeTab}>
            {visibleContentTabs.map((tab) => {
              const content =
                tab.wrapContent === false ? tab.content : <div className="diamondDetailImageBox">{tab.content}</div>;
              return (
                <TabPane key={tab.id} tabId={tab.id} className={tab.paneClassName}>
                  {content}
                </TabPane>
              );
            })}
          </TabContent>
        ) : (
          ''
        )}
        <hr />
        {hasToken || props.shared.length > 1 ? (
          <>
            <Nav tabs className="DNAdiamondDetailTopTab">
              {visibleNavTabs.map((tab) => (
                <NavItem key={tab.id}>
                  <NavLink className={classnames({ active: activeTab === tab.id })} onClick={() => toggle(tab.id)}>
                    <div className="DNAdiamondDetailTabText">
                      <div className="DNAdiamondDetailTabImage">
                        <img src={tab.thumbSrc} onError={tab.onThumbError} />
                      </div>
                      <div className={tab.id === '10' ? 'DNAdiamondDetailTabTextBlackBackground' : ''}>{tab.label}</div>
                    </div>
                  </NavLink>
                  {tab.copyable && activeTab === tab.id && tab.showContent && (
                    <div className="copy-icon">
                      <Tooltip placement="bottom" title={copyText}>
                        <Icon
                          type="copy"
                          onClick={() => copyURL(FILE_URLS.videoFile.replace('***', props.item.vStnId))}
                        />
                      </Tooltip>
                    </div>
                  )}
                </NavItem>
              ))}
            </Nav>
          </>
        ) : (
          ''
        )}
        <div style={{ minHeight: '10px', height: '10px' }}></div>
      </>
    </>
  );
};

export default withRouter(DiamondDetailLeft);
